import { InputWrapper } from '../styled/ManageInstance.styled';

/* eslint-disable class-methods-use-this */
class FieldModel {
  /**
   * @param {Object} params
   * @param {string} params.kWord Unique object key (from plans)
   * @param {string} params.label Input label, used on the field filter
   * @param {boolean} [params.required] If the input is required to save
   * @param {boolean} [params.removed] Condition to not render and use this field
   * @param {boolean|function} [params.disabled] Condition to block this field (still visible)
   * @param {any} [params.default] Default (initial) value
   */
  constructor(params) {
    this.id = `field-${params.kWord}`;
    Object.assign(this, params);
  }

  /** @abstract */
  getDefaultState = () => { throw new Error('Method not implemented.'); }

  /** @abstract */
  fieldComponent = () => { throw new Error('Method not implemented.'); }

  genFormatedState = (value) => (
    value !== undefined ? { value, error: false, errorMsg: '' } : null
  )

  scrollToField = () => {
    document.getElementById(this.id).scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  checkDisabled = (state) => {
    if (typeof this.disabled === 'function') {
      return Boolean(this.disabled(state));
    } return Boolean(this.disabled);
  }

  renderComponent = (tempState, state, handle) => (this.removed ? null : (
    <InputWrapper
      id={this.id}
      key={this.id}
      disabled={this.checkDisabled(state)}
    >
      {this.fieldComponent(tempState, state, handle)}
    </InputWrapper>
  ))
}

export default FieldModel;
